import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./FichaPrevia.css";
import { getAgendaPublica, getFichaPublica } from "../../services/citas";

/**
 * Aviso de privacidad para pacientes (PÚBLICO, se abre en otra pestaña).
 *
 * /aviso-privacidad/agenda/:id  -> id = link del médico (página pública de citas)
 * /aviso-privacidad/ficha/:id   -> id = token de la ficha previa
 *
 * El texto viene del back (aviso_privacidad_paciente.py): aquí solo se muestra.
 */
const AvisoPrivacidadPaciente = () => {
  const { tipo, id } = useParams();

  const [cargando, setCargando] = useState(true);
  const [aviso, setAviso] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const cargar = async () => {
      let resp = null;
      if (tipo === "agenda") resp = await getAgendaPublica(id);
      if (tipo === "ficha") resp = await getFichaPublica(id);

      const completo = resp?.ok ? resp.data?.aviso_privacidad?.completo : null;
      if (completo) {
        setAviso(completo);
      } else {
        setError("No se pudo mostrar el aviso de privacidad. Solicítalo directamente al consultorio.");
      }
      setCargando(false);
    };
    cargar();
  }, [tipo, id]);

  if (cargando) {
    return (
      <div className="ficha-pagina">
        <div className="ficha-tarjeta"><p>Cargando…</p></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ficha-pagina">
        <div className="ficha-tarjeta">
          <h2 className="ficha-titulo">Aviso de privacidad</h2>
          <p className="ficha-mensaje">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ficha-pagina">
      <article className="ficha-tarjeta aviso-pagina">
        <h1 className="aviso-pagina-titulo">{aviso.titulo}</h1>
        <p className="aviso-pagina-fecha">Última actualización: {aviso.actualizado}</p>

        {(aviso.secciones || []).map((seccion) => (
          <section key={seccion.titulo} className="aviso-pagina-seccion">
            <h2>{seccion.titulo}</h2>
            {(seccion.parrafos || []).map((texto, i) => (
              <p key={`p-${i}`}>{texto}</p>
            ))}
            {seccion.lista?.length > 0 && (
              <ul>
                {seccion.lista.map((texto, i) => (
                  <li key={`l-${i}`}>{texto}</li>
                ))}
              </ul>
            )}
            {(seccion.parrafos_final || []).map((texto, i) => (
              <p key={`f-${i}`}>{texto}</p>
            ))}
          </section>
        ))}

        <p className="aviso-pagina-nota">
          Puedes cerrar esta pestaña para regresar a tu formulario.
        </p>
      </article>
    </div>
  );
};

export default AvisoPrivacidadPaciente;